import { render, staticRenderFns } from "./NotificationEditor.vue?vue&type=template&id=07baba9a&scoped=true&"
import script from "./NotificationEditor.vue?vue&type=script&lang=js&"
export * from "./NotificationEditor.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEditor.vue?vue&type=style&index=0&id=07baba9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07baba9a",
  null
  
)

export default component.exports